<template>
  <div class="recharge">
    <div class="rechargeMain">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="账户管理" name="first" v-if="$attrs.methodAuthTabView('账户管理')">
          <el-form ref="form" :model="form" size="small" :inline="true">
            <el-form-item label="充值账户:">
              <el-input v-model="form.account_no" placeholder="请输入充值账户" clearable></el-input>
            </el-form-item>
            <el-form-item label="关联学员:">
              <autocomplete @getUserId="getUserId"></autocomplete>
            </el-form-item>
            <el-form-item label="实充余额:">
              <div style="overflow: hidden;">
                <div class="fl">
                  <el-input v-model="form.amount_start" style="width: 100px;" clearable></el-input>
                </div>
                <div class="fl">
                  <span style="margin-left:5px;margin-right:5px;">~</span>
                </div>
                <div class="fl">
                  <el-input v-model="form.amount_end" style="width: 100px;" clearable></el-input>
                </div>
              </div>
            </el-form-item>
            <br />
            <el-form-item label="赠送余额:">
              <div style="overflow: hidden;">
                <div class="fl">
                  <el-input v-model="form.give_amount_start" style="width: 100px;" clearable></el-input>
                </div>
                <div class="fl">
                  <span style="margin-left:5px;margin-right:5px;">~</span>
                </div>
                <div class="fl">
                  <el-input v-model="form.give_amount_end" style="width: 100px;" clearable></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="累计实充金额:">
              <div style="overflow: hidden;">
                <div class="fl">
                  <el-input v-model="form.history_amount_start" style="width: 100px;" clearable></el-input>
                </div>
                <div class="fl">
                  <span style="margin-left:5px;margin-right:5px;">~</span>
                </div>
                <div class="fl">
                  <el-input v-model="form.history_amount_end" style="width: 100px;" clearable></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="累计赠送金额:">
              <div style="overflow: hidden;">
                <div class="fl">
                  <el-input v-model="form.history_give_amount_start" style="width: 100px;" clearable></el-input>
                </div>
                <div class="fl">
                  <span style="margin-left:5px;margin-right:5px;">~</span>
                </div>
                <div class="fl">
                  <el-input v-model="form.history_give_amount_end" style="width: 100px;" clearable></el-input>
                </div>
              </div>
            </el-form-item>
            <br />

            <el-form-item label="总余额:">
              <div style="overflow: hidden;">
                <div class="fl">
                  <el-input v-model="form.total_amount_start" style="width: 100px;" clearable></el-input>
                </div>
                <div class="fl">
                  <span style="margin-left:5px;margin-right:5px;">~</span>
                </div>
                <div class="fl">
                  <el-input v-model="form.total_amount_end" style="width: 100px;" clearable></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="search" v-if="$attrs.methodAuthTabView('账户管理', '查询')">查询</el-button>
              <el-button type="primary" @click="goNextRecharge" v-if="$attrs.methodAuthTabView('账户管理', '充值')">充值</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tableData" style="width: 100%" :header-cell-style="{
              background: '#f5f7fa',
              color: '#606266',
              'font-size': '14px',
            }" size="small">
            <el-table-column align="center" width="50" label="序号">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 + 20 * (page_no - 1) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="account_no" label="账户名称" width="150px">
              <template slot-scope="scope">
                <el-link type="primary" @click="changeName(scope.row)">{{
                  scope.row.account_no
                }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="" label="关联学员" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.xmAccountStuInfoArr.length === 0">暂无关联学员</span>
                <span v-else>
                  <span v-for="(item, index) in scope.row.xmAccountStuInfoArr" :key="index" class="table-hide">
                    <el-tag size="mini" style="margin-right:5px;">
                      {{ item.stu_realname }}</el-tag>
                    <span class="symbol-comma" v-if="index<scope.row.xmAccountStuInfoArr.length-1">,</span>
                  </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="总余额">
              <template slot-scope="scope">
                <span>￥{{ scope.row.total_amount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="实充余额">
              <template slot-scope="scope">
                <span>￥{{ scope.row.amount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="赠送余额">
              <template slot-scope="scope">
                <span>￥{{ scope.row.give_amount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="累计实充金额">
              <template slot-scope="scope">
                <span>￥{{ scope.row.history_amount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="累计赠送金额">
              <template slot-scope="scope">
                <span>￥{{ scope.row.history_give_amount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" width="230">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="goNext(scope.row)">充值</el-button>
                <el-button type="text" size="mini" @click="goNext1(scope.row)">退款</el-button>
                <el-button type="text" size="mini" @click="delStuList(scope.row)">管理关联学员</el-button>
                <el-button type="text" size="mini" @click="activechange(scope.row)">变动记录</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 30px; text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page="page_no" :page-size="page_size" layout="total,prev, pager, next" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="账户变动记录" name="second" v-if="$attrs.methodAuthTabView('账户变动记录')">
          <el-form ref="form" :model="form1" size="small" :inline="true">
            <el-form-item label="充值账户:">
              <el-input v-model="form1.account_no" placeholder="请输入充值账户" clearable style="width:150px;"></el-input>
            </el-form-item>
            <el-form-item label="变动类型:">
              <el-select v-model="form1.type" placeholder="请选择活动区域" clearable>
                <el-option label="账户充值" value="1"></el-option>
                <el-option label="账户退款" value="2"></el-option>
                <el-option label="账户支出" value="3"></el-option>
                <el-option label="退款至账户" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经办人:">
              <el-select v-model="form1.deal_user_id" collapse-tags placeholder="请选择" clearable>
                <el-option v-for="item in user_list" :key="item.id" :label="item.realname + ' ' + '(' + item.name + ')'" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间:">
              <el-date-picker v-model="form1.time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" placement="bottom-start">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="">
              <el-button type="primary" @click="search1" v-if="$attrs.methodAuthTabView('账户变动记录', '查询')">查询</el-button>
              <el-button type="primary" @click="goNextRecharge" v-if="$attrs.methodAuthTabView('账户变动记录', '充值')">充值</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tableData1" style="width: 100%" :header-cell-style="{
              background: '#f5f7fa',
              color: '#606266',
              'font-size': '14px',
            }">
            <el-table-column prop="xm_account_no" label="充值账户">
            </el-table-column>
            <el-table-column prop="stu_str" label="关联学员" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="" label="变动类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 1">账户充值</span>
                <span v-if="scope.row.type === 2">账户退款</span>
                <span v-if="scope.row.type === 3">账户支出</span>
                <span v-if="scope.row.type === 4">退款至账户</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="实充余额">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 1">+￥{{ scope.row.amount.toFixed(2) }}</span>
                <span v-if="scope.row.type === 2">-￥{{ scope.row.amount.toFixed(2) }}</span>
                <span v-if="scope.row.type === 3">-￥{{ scope.row.amount.toFixed(2) }}</span>
                <span v-if="scope.row.type === 4">+￥{{ scope.row.amount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="赠送余额">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 1">+￥{{ scope.row.give_amount.toFixed(2) }}</span>
                <span v-if="scope.row.type === 2">-￥{{ scope.row.give_amount.toFixed(2) }}</span>
                <span v-if="scope.row.type === 3">-￥{{ scope.row.give_amount.toFixed(2) }}</span>
                <span v-if="scope.row.type === 4">+￥{{ scope.row.give_amount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="deal_user_realname" label="经办人">
            </el-table-column>
            <el-table-column prop="created_time" label="创建时间" show-overflow-tooltip>
            </el-table-column>
          </el-table>
          <div style="margin-top: 30px; text-align: right">
            <el-pagination @current-change="handleCurrentChange1" :current-page="page_no1" :page-size="page_size1" layout="total,prev, pager, next" :total="total1"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="修改账户" :visible.sync="dialogVisible" width="30%">
      <el-form ref="formaccount" :model="formaccount" :rules="rules">
        <el-form-item label="账户名称" prop="account_no">
          <el-input maxlength="11" v-model="formaccount.account_no" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitaccount('formaccount')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="关联学员列表" :visible.sync="dialogVisible1" width="50%">
      <div style="margin-bottom:10px">
        <el-button type="primary" size="mini" @click="addStu">添加关联学员</el-button>
      </div>
      <el-table size="mini" :data="tableData2" style="width: 100%" :header-cell-style="{
          background: '#f5f7fa',
          color: '#606266',
          'font-size': '14px',
        }">
        <el-table-column prop="xm_account_no" label="头像">
          <template slot-scope="scope">
            <div style="width:40px;height:40px;border-radius:50%;overflow:hidden">
              <img :src="scope.row.stu_headImgUrl" alt="" style="width:100%" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stu_realname" label="学员姓名">
        </el-table-column>
        <el-table-column prop="stu_username" label="账号"> </el-table-column>
        <el-table-column prop="created_time" label="创建时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible1 = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="dialogVisible1 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加关联学员" :visible.sync="dialogVisible2" v-if="dialogVisible2" width="80%" top="5vh">
      <el-form :inline="true" size="mini" label-width="500" @submit.native.prevent>
        <el-form-item label="">
          <el-input v-model="formInlineStu.user" placeholder="请输入学员姓名" style="width:250px;" @keyup.enter.native="searchStu" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchStu">查询</el-button>
        </el-form-item>
      </el-form>
      <div style="overflow: hidden;">
        <div class="fl" style="width: calc(70% - 5px);">
          <el-table :row-key="(row) => row.id" ref="multipleTable" :data="tabledataStu" :header-cell-style="{
              background: '#f5f7fa',
              color: '#606266',
              'font-size': '14px',
            }" stripe style="width: 100%;border:1px solid #f5f7fa;" height="55vh" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" :reserve-selection="true">
            </el-table-column>
            <el-table-column type="index" width="50" label="序号">
            </el-table-column>
            <el-table-column prop="" label="学员姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.realname }}</span>
              </template>
            </el-table-column>

            <el-table-column label="性别">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.sex }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="平台账号" show-overflow-tooltip>
            </el-table-column>

            <el-table-column label="联系电话">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.parent_a }}</span><br />
                <span>{{ scope.row.studentUserInfo.parent_a_phone_num }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 30px; text-align: right">
            <el-pagination @current-change="handleCurrentChangeStu" :current-page="page_noStu" :page-size="page_sizeStu" layout="total,prev, pager, next" :total="totalStu"></el-pagination>
          </div>
        </div>
        <div class="fl" style="margin-left: 10px;width: calc(30% - 5px);overflow-y: auto;margin-top: 0px;">
          <div style="height: calc(55vh);border: 1px solid #f5f7fa; border-radius: 5px;padding: 10px;">
            <ul>
              <li v-for="(item, index) in multipleSelection" :key="index" style="margin-bottom: 10px;border-bottom: 1px solid #f5f7fa;padding-bottom: 10px;">
                <div style="overflow: hidden;">
                  <div class="fl">{{ item.studentUserInfo.realname }}</div>
                  <div class="fr" style="cursor: pointer;" @click="deleteStu(item)">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible2 = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitStu">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import autocomplete from '@/components/autocomplete'
import {
  getXmAccountList,
  getCampusUserList,
  getXmAccountRecordList,
  updateXmAccount,
  getXmAccountStuList,
  delXmAccountStu,
  getFormalStudentList,
  addXmAccountStu,
  getXmAccountInfoByAccountNo,
} from '@/api/educational'
export default {
  components: {
    autocomplete,
  },
  data() {
    return {
      dialogVisible2: false,
      multipleSelection: [],
      //创建搜索学员
      formInline: {
        rechargeAmount: '',
      },
      formInlineStu: {},
      xmAccountData: {},
      account_no1: '',
      page_noStu: 1,
      page_sizeStu: 10,
      totalStu: 0,
      tabledataStu: [],
      chooseStudent: {},
      educational_institution_campus_id: '',
      tableData2: [],
      dialogVisible1: false,
      xm_account_id: '',
      formaccount: {
        account_no: '',
        account_id: '',
      },
      dialogVisible: false,
      tableData1: [],
      page_no1: 1,
      page_size1: 10,
      total1: 0,
      user_list: [], //校区负责人列表
      form1: {
        account_no: '',
        time: [],
      },
      activeName: 'first',
      page_no: 1,
      page_size: 10,
      total: 0,
      form: {},
      tableData: [],
      rules: {
        account_no: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号格式不正确',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getXmAccountList()
    this.getCampusUserList()
  },
  methods: {
    //查询学员
    //查询在读学员
    getFormalStudentList() {
      getFormalStudentList({
        realname: this.formInlineStu.user,
        // campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        campusIds: JSON.stringify([this.educational_institution_campus_id]),
        page_no: this.page_noStu,
        page_size: this.page_sizeStu,
      }).then((res) => {
        console.log('查询所有在读学员')
        console.log(res, 1512652)
        this.tabledataStu = res.studentList
        this.totalStu = res.total
      })
    },
    addStu() {
      this.getFormalStudentList()
      this.dialogVisible2 = true
    },
    submitStu() {
      //创建回显
      this.stuIdArr = []
      this.multipleSelection.map((item) => {
        console.log(item, 154512)
        this.stuIdArr.push(item.id)
      })
      this.addXmAccountStu()
      setTimeout(() => {
        //查询
        getXmAccountInfoByAccountNo({
          account_no: this.account_no1,
          campusIdArr: JSON.stringify([this.educational_institution_campus_id]),
        }).then((res) => {
          res.xmAccountList.map((item) => {
            this.xmAccountData = item
          })
          console.log(res, 465232)
        })
      }, 1000)

      this.dialogVisible2 = false
      this.multipleSelection = []
      this.tabledataStu = []

    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleCurrentChangeStu(val) {
      this.page_noStu = val
      this.getFormalStudentList()
    },
    Cancel_ChooseStudent() {
      this.dialogVisible1 = false
      console.log('取消选择学员')
    },
    addXmAccountStu() {
      addXmAccountStu({
        stuIdArr: JSON.stringify(this.stuIdArr),
        xm_account_id: this.xmAccountData.id,
      }).then((res) => {
        console.log(res, 4512)
        if (res.is_created === true) {
          this.$message.success('关联成功')
          this.getXmAccountStuList();
          this.getXmAccountList()
        }
      })
    },
    searchStu() {
      console.log(121212, 456362)
      this.page_noStu = 1
      this.getFormalStudentList()
    },
    del(row) {
      console.log(row, 12152)
      // delXmAccountStu
      this.$confirm('是否取消关联?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delXmAccountStu({
            id: row.id,
          }).then((res) => {
            console.log(res, 124545)
            this.getXmAccountStuList()
            this.getXmAccountList()
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    delStuList(val) {
      console.log(val, 123456)
      this.educational_institution_campus_id = val.educational_institution_campus_id;
      this.xm_account_id = val.id
      this.getXmAccountStuList()
      this.dialogVisible1 = true
      this.xmAccountData = val
      this.account_no1 = val.account_no
      // this.multipleSelection = val.xmAccountStuInfoArr
    },
    getXmAccountStuList() {
      getXmAccountStuList({
        xm_account_id: this.xm_account_id,
      }).then((res) => {
        console.log(res, 12456)
        this.tableData2 = res.xmAccountStuList
      })
    },
    submitaccount(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateXmAccount({
            account_no: this.formaccount.account_no,
            account_id: this.formaccount.account_id,
          }).then((res) => {
            console.log(res)
            if (res.is_update) {
              this.$message.success('修改成功')
              this.dialogVisible = false
              this.getXmAccountList()
            } else {
              this.$message.warning(res.msg)
              this.dialogVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    changeName(row) {
      this.formaccount.account_no = row.account_no
      this.formaccount.account_id = row.id
      this.dialogVisible = true
      console.log(row, 123456)
    },
    activechange(row) {
      console.log(row, 789456)
      this.activeName = 'second'
      this.form1.account_no = row.account_no
      this.search1()
    },
    goNext1(row) {
      this.$router.push({
        name: 'accountRefund',
        query: {
          account_no: row.account_no,
        },
      })
    },
    goNextRecharge() {
      this.$router.push({
        name: 'accountRecharge',
      })
    },
    goNext(row) {
      console.log(row, 789464)
      this.$router.push({
        name: 'accountRecharge',
        query: {
          account_no: row.account_no,
        },
      })
    },
    search1() {
      this.page_no1 = 1
      this.getXmAccountRecordList()
    },
    handleCurrentChange1(val) {
      this.page_no1 = val
      this.getXmAccountRecordList()
    },
    getXmAccountRecordList() {
      let time1 = ''
      let time2 = ''
      if (this.form1.time === null || this.form1.time.length === 0) {
        time1 = ''
        time2 = ''
      } else {
        time1 = this.form1.time[0]
        time2 = this.form1.time[1]
      }
      getXmAccountRecordList({
        type: this.form1.type,
        campusIdArr: JSON.stringify(this.$store.state.user.selected_schools),
        account_no: this.form1.account_no,
        deal_user_id: this.form1.deal_user_id,
        page_no: this.page_no1,
        page_size: this.page_size1,
        created_time_start: time1,
        created_time_end: time2,
      }).then((res) => {
        this.tableData1 = res.xmRecordAccountList
        this.total1 = res.total
      })
    },
    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.user_list = res.campusUserList
      })
    },
    handleClick(val) {
      console.log(val.index, 4512)
      if (val.index === 0) {
        this.getXmAccountList()
      } else {
        this.getXmAccountRecordList()
      }
    },
    search() {
      this.page_no = 1
      this.getXmAccountList()
    },
    getUserId(val) {
      console.log(val, 45645)
      this.form.stuId = val
    },
    getXmAccountList() {
      getXmAccountList({
        page_no: this.page_no,
        page_size: this.page_size,
        campusIdArr: JSON.stringify(this.$store.state.user.selected_schools),
        ...this.form,
      }).then((res) => {
        console.log(res, 4512)
        this.tableData = res.xmAccountList
        this.total = res.total
      })
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getXmAccountList()
    },
  },
}
</script>
<style scoped>
.recharge {
  padding: 10px;
}

.rechargeMain {
  min-height: calc(100vh - 80px);
  background-color: #fff;
  padding: 10px 10px 10px 20px;
  border-radius: 5px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}
.table-hide span.symbol-comma {
  opacity: 0;
}
</style>
